import { AnyAction } from 'redux';
import { AxiosResponseTransformer as AxiosTransformer } from 'axios';
import { AngebotsId } from './angebotsId';

export enum HTTP_METHOD {
  GET = 'GET',
  POST = 'POST',
}

export enum ResponseType {
  APPLICATION_JSON = 'json',
  PLAIN_TEXT = 'text',
  ARRAY_BUFFER = 'arraybuffer',
}

export interface Retry {
  times: number;
  delay: number;
}

export interface DoRequest<T = unknown> extends AngebotsId {
  body?: T;
  url: string;
  successEvent: string;
  errorEvent: string;
  originEvent?: AnyAction;
  method?: HTTP_METHOD;
  responseType?: ResponseType;
  noCache?: boolean;
  retry?: Retry;
  transformResponse?: AxiosTransformer | AxiosTransformer[];
  additionalData?: unknown;
}
